import React, { useEffect, useState } from "react";
import "./AddQuoteModal.css";
import { toast } from "react-toastify";

const AddQuoteModal = ({ isOpen, onClose, onSubmit, clientId, queryData }) => {
  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  const tomorrow = tomorrowDate.toISOString().split("T")[0];
  const [form, setForm] = useState({
    budget: "",
    startDate: "",
    endDate: "",
    location: "",
    note: "",
    eventType: "",
    isQuoteFinal: false,
  });

  useEffect(() => {
    if (queryData) {
      setForm({
        budget: queryData?.budget || "",
        startDate: queryData?.startDate
          ? queryData.startDate.split("T")[0]
          : "",
        endDate: queryData?.endDate
          ? queryData.endDate.split("T")[0]
          : "",
        location: queryData?.location || "",
        note: "",
        eventType: queryData?.eventType,
        isQuoteFinal: queryData?.isQuoteFinal || false,
      });
    }
  }, [queryData]);


  if (!isOpen) return null;


  // const handleToggle = () => {
  //   setForm({ ...form, isQuoteFinal: !form.isQuoteFinal });
  // };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSend = () => {
    if (form.eventType !== "Editing" && form.startDate > form.endDate) {
      alert("Start date cannot be greater than end date");
      return;
    }
    // if (!form.budget || !form.startDate || !form.endDate || !form.flatOrHouseNo || !form.streetName || !form.city || !form.state || !form.postalCode) {
    //   alert("Please fill required fields");
    //   return;
    // }

    const requiredFields = [
      { key: "budget", label: "Budget" },
      { key: "endDate", label: form.eventType === "Editing" ? "Delivery Date" : "End Date" },
    ];

    if (form.eventType !== "Editing") {
      requiredFields.push({ key: "startDate", label: "Start Date" });
    }

    for (let field of requiredFields) {
      if (!form[field.key]) {
        toast.error(`${field.label} is required`);
        return;
      }
    }

    onSubmit({
      messageType: "paymentCard",
      budget: form.budget,
      startDate: form.eventType === "Editing" ? form.endDate : form.startDate,
      endDate: form.endDate,
      location: form.location,
      message: form.note,
      createdAt: new Date().toISOString(),
      senderId: sessionStorage?.getItem("myId"),
      clientId: clientId,
      isQuoteFinal: true,
    });
    // refreshData()
    onClose();

  };

  console.log("FORM DATA BUDGET", form?.budget)


  return (
    <div className="aqm-backdrop">
      <div className="aqm-modal">

        {(form.eventType === "Wedding Photography" || form.eventType === "Maternity and Baby Shoot") && <p className="note"><strong>Note : </strong>Client Budget is {form.budget}</p>}
        {/* Budget */}
        <div className="aqm-row">
          <label>Budget *</label>
          <input
            type="number"
            name="budget"
            placeholder="₹ Enter Budget"
            value={form.budget}
            onChange={handleChange}
          />
        </div>

        {/* Event Dates / Delivery Date */}
        <div className="aqm-row">
          <label>{form.eventType === "Editing" ? "Delivery Date *" : "Event Dates *"}</label>
          <div className="aqm-dates">
            {form.eventType !== "Editing" && (
              <>
                <span>From</span>
                <input
                  type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
                  name="startDate"
                  value={form.startDate}
                  onChange={handleChange}
                  min={tomorrow}
                />
                <span>To</span>
              </>
            )}
            <input
              type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
              name="endDate"
              value={form.endDate}
              onChange={handleChange}
              min={tomorrow}
            />
          </div>
        </div>

        {/* Event Location (Area) */}
        <div className="aqm-row">
          <label>Event Area</label>
          <input
            type="text"
            name="location"
            placeholder="e.g. Rohini"
            value={form.location}
            onChange={handleChange}
          />
        </div>

        {/* <h4 className="my-toggle-text">Event Address</h4>

        <div className="aqm-row">
          <label>Flat / House No</label>
          <input
            type="text"
            name="flatOrHouseNo"
            value={form.flatOrHouseNo}
            onChange={handleChange}
          />
        </div>

        <div className="aqm-row">
          <label>Street Name</label>
          <input
            type="text"
            name="streetName"
            value={form.streetName}
            onChange={handleChange}
          />
        </div>

        <div className="aqm-row">
          <label>City</label>
          <input
            type="text"
            name="city"
            value={form.city}
            onChange={handleChange}
          />
        </div>

        <div className="aqm-row">
          <label>State</label>
          <input
            type="text"
            name="state"
            value={form.state}
            onChange={handleChange}
          />
        </div>

        <div className="aqm-row">
          <label>Postal Code</label>
          <input
            type="text"
            name="postalCode"
            value={form.postalCode}
            onChange={handleChange}
          />
        </div> */}
        {/* <hr className="my-toggle-text" />

        <div className="aqm-toggle-row">
          <span className="my-toggle-text"> Are you sure to Convert query into final quote?</span>

          <label className="switch">
            <input
              type="checkbox"
              checked={form.isQuoteFinal}
              onChange={handleToggle}
            />
            <span className="slider"></span>
          </label>
        </div> */}

        {/* Note */}
        <div className="aqm-row full">
          <label>Your Message (optional)</label>
          <textarea
            name="note"
            placeholder="Add Note"
            value={form.note}
            onChange={handleChange}
          />
        </div>

        {/* Actions */}
        <div className="aqm-actions">
          <button className="cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="send" onClick={handleSend}>
            Send
          </button>

        </div>

      </div>
    </div>
  );
};

export default AddQuoteModal;


// import React, { useState } from "react";
// import "./AddQuoteModal.css";

// const AddQuoteModal = ({ isOpen, onClose, onSubmit }) => {
//   const [form, setForm] = useState({
//     budget: "",
//     startDate: "",
//     endDate: "",
//     location: "",
//     note: "",
//   });

//   if (!isOpen) return null;

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSend = () => {
//     onSubmit({
//       messageType: "paymentCard",
//       //   eventType: {
//       budget: form.budget,
//       startDate: form.startDate,
//       endDate: form.endDate,
//       location: form.location,
//       //   },
//       message: form.note,
//       createdAt: new Date().toISOString(),

//       // ✅ ADD THIS
//       senderId: sessionStorage?.getItem("myId"),
//     });
//     onClose();
//   };

//   const DELHI_CITIES = [
//     // Central Delhi
//     "Connaught Place",
//     "Chandni Chowk",
//     "Karol Bagh",
//     "Paharganj",
//     "Darya Ganj",

//     // North Delhi
//     "Sadar Bazar",
//     "Civil Lines",
//     "Shahdara",
//     "Rohini",
//     "Pitampura",
//     "Ashok Vihar",
//     "Narela",
//     "Azadpur",

//     // South Delhi
//     "Hauz Khas",
//     "Saket",
//     "Defence Colony",
//     "Vasant Kunj",
//     "Greater Kailash",
//     "Lajpat Nagar",
//     "Malviya Nagar",
//     "Chhatarpur",

//     // West Delhi
//     "Rajouri Garden",
//     "Punjabi Bagh",
//     "Janakpuri",
//     "Vikaspuri",
//     "Moti Nagar",

//     // East Delhi
//     "Mayur Vihar",
//     "Preet Vihar",
//     "Patparganj",
//     "Kondli",
//     "Shahdara",

//     // New Delhi
//     "Chanakyapuri",
//     "Jor Bagh",
//     "Vasant Vihar",
//     "Dhaula Kuan",
//     "Indraprastha",

//     // Other areas
//     "Nangloi",
//     "Bawana",
//     "Kanjhawala",
//     "Burari",
//     "Alipur",
//     "Timarpur"
//   ];




//   return (
//     <div className="aqm-backdrop">
//       <div className="aqm-modal">
//         {/* Budget */}
//         <div className="aqm-row">
//           <label>Budget</label>
//           <input
//             type="number"
//             name="budget"
//             placeholder="₹ Enter Budget"
//             value={form.budget}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Event Dates */}
//         <div className="aqm-row">
//           <label>Event Dates</label>
//           <div className="aqm-dates">
//             <span>From</span>
//             <input
//               type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
//               name="startDate"
//               value={form.startDate}
//               onChange={handleChange}
//             />
//             <span>To</span>
//             <input
//               type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
//               name="endDate"
//               value={form.endDate}
//               onChange={handleChange}
//             />
//           </div>
//         </div>

//         {/* City */}
//         {/* <div className="aqm-row">
//           <label>Event City</label>
//           <select
//             name="location"
//             value={form.location}
//             onChange={handleChange}
//           >
//             <option value="">Select City</option>
//             <option value="Mumbai">Mumbai</option>
//             <option value="Delhi">Delhi</option>
//             <option value="Bangalore">Bangalore</option>
//           </select>
//         </div> */}

//         {/* const CITIES = ["Delhi"]; // ✅ Only Delhi available */}

//         <div className="aqm-row">
//           <label>Event City</label>
//           <select
//             name="location"
//             value={form.location}
//             onChange={handleChange}
//           >
//             <option value="">Select City</option>
//             {DELHI_CITIES.map((city) => (
//               <option key={city} value={city}>
//                 {city}
//               </option>
//             ))}
//           </select>
//         </div>
//         {/* Note */}
//         <div className="aqm-row full">
//           {/* <label>Any photography requests or extra details?</label> */}
//           <label>Your Message (optional)</label>

//           <textarea
//             name="note"
//             placeholder="Add Note"
//             value={form.note}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Actions */}
//         <div className="aqm-actions">
//           <button className="send" onClick={handleSend}>
//             Send
//           </button>
//           <button className="cancel" onClick={onClose}>
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddQuoteModal;
